<style>
.bg-primary {
  background-color: #1a3665 !important;
}
</style>
<template>
  <div class="card">
    <div class="card-header bg-primary font-weight-bold text-white d-flex align-items-center">
      Paket Kuesioner
      <Button
        class="btn btn-md btn-dark px-4 py-2 ml-auto text-white"
        @click="$router.go(-1)"
      >Kembali</Button>
    </div>    
  <form id="form-data" @submit.prevent="postData">  
    <div class="card-body">
      <div class="card border-0 shadow p-2">
        <div class="card-body">
          <div>
            <div class="form-row">
              <div class="form-group col-md-11">
                <label for="nama" class="font-weight-bold">Nama Paket Kuesioner</label>
                <input
                  type="text"
                  class="form-control"
                  id="nama"
                  v-model="formData.namaKusioner"
                  placeholder="Masukkan nama paket kuesioner"
                  required
                />
              </div>
            </div>
            <div class="form-row" v-for="(input,k) in formData.pertanyaan" :key="k">
              <div class="form-group col-md-11">
                <label for="pertanyaan" class="font-weight-bold">Pertanyaan</label>
                  <select 
                    class="form-control" 
                    name 
                    id
                    v-model="input.id_pertanyaan"
                    @change="pilihPertanyaan($event,k)">
                    <option selected disabled>- Pilih Pertanyaan -</option>
                    <option 
                    v-for="(item,key) in dat_kuesioner"
                    :value="item.idPertanyaan"
                    :key="key"
                    >{{ key+1 }}. {{ item.pertanyaan ? item.pertanyaan: '-' }}
                    </option>
                  </select>                
              </div>
              <div class="col-1 d-flex align-items-center mt-2">
                <button
                  class="btn btn-sm btn-success ml-2"
                  @click="add_kuesioner(k)"
                  v-show="k == formData.pertanyaan.length-1"
                >
                  <i class="fa fa-plus" aria-hidden="true"></i>
                </button>
                <button
                  class="btn btn-sm btn-danger ml-2"
                  @click="remove_kuesioner(k)"
                  v-show="k || ( !k && formData.pertanyaan.length > 1)"
                >
                  <i class="fa fa-trash" aria-hidden="true"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <CCol sm="12">
          <label for class="font-weight-bold">Status</label>
          <br />
          <div class="d-flex align-items-center">
            <div class="custom-control custom-radio custom-control-inline">
              <input
                type="radio"
                class="custom-control-input"
                value="1"
                v-model="formData.status"
                required
                name="customRadio"
                id="aktif"
                checked="true"
              />
              <label class="custom-control-label" for="aktif">Aktif</label>
            </div>
            <div class="custom-control custom-radio custom-control-inline">
              <input
                type="radio"
                class="custom-control-input"
                value="0"
                required
                v-model="formData.status"
                name="customRadio"
                id="tidak_aktif"
              />
              <label class="custom-control-label" for="tidak_aktif">Tidak Aktif</label>
            </div>
          </div>
        </CCol>
      </div>
    </div>
  
    <div class="card-footer bg-white border-0 text-right mb-3 mr-3">
        <Button
          class="btn btn-md btn-success px-4 py-2"
          type="submit"
          color="success"
        >Simpan</Button>
    </div>
  </form>
 </div>
</template>
<script>
import KuesionerService from "../../../services/pelatihan/kuesioner.service";
import PaketKuesionerService from "../../../services/pelatihan/paket_kuesioner.service";

export default {
  data() {
    return {
      dat_kuesioner: [],
      kuesioner: [
        {
        //   idPertanyaan: "",
          pertanyaan: "",
         
        }
      ],
      formData: {
        namaKusioner: "",
        status: "",
        pertanyaan: [
          {
             idPertanyaan: "",
             pertanyaan: "",
             idPertanyaanKuesioner: ""
            
          }
        ]
      },
    
    };
  },
  mounted() {
    this.getData();
    this.getDetailKuesioner();
  },

  methods: {
    getDetailKuesioner(){
        let loader = this.$loading.show({
            container: false ? null : this.$refs.formContainer,
            canCancel: true,
            onCancel: this.onCancel
        });
        var vm = this;
        PaketKuesionerService.getDetailPaketKuesioner(this.$route.params.id_kuesioner)
        .then(response => {
            loader.hide();
            vm.formData = response.data.singleData;
            vm.formData.namaKusioner = response.data.singleData.namaKuesioner;
            vm.formData.status = response.data.singleData.status;
        })
        .catch(error => {
            // comment console console.log(error);
        });
    },
    postData(){
      this.insertData(this.formData);
    },
    insertData(formData){
      let loader = this.$loading.show({
        container: false ? null : this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel
      });
      for(let index = 0; index < formData.pertanyaan.length; index++){
        for(let indexTwo = index + 1;indexTwo < formData.pertanyaan.length; indexTwo++) {
          if(
            formData.pertanyaan[index].idPertanyaan ==
            formData.pertanyaan[indexTwo].idPertanyaan
          ) {
            this.alertError("Tidak Boleh Ada Mata Uji Yang Sama");
            return false;
          }
        }
      }

      var vm = this;

      PaketKuesionerService.putKuesioner(
      formData,
      vm.$route.params.id_kuesioner)
      .then(response => {
        loader.hide();
        vm.myModal = false;
        vm.alertSuccess();
        vm.getDetailKuesioner();
        vm.$router.push({ path: "/pelatihan/paket-kuesioner" });
      })
      .catch(error => {
        loader.hide();
        vm.alertError(error.response.data.message);
      })
      
    },
    pilihPertanyaan(event,k){
      var data = event.target.value.split(".");
      var el = this.dat_kuesioner.find(event => event.idPertanyaan == event.target.value);
   
       this.formData.pertanyaan[k].idPertanyaan = el.idPertanyaan;
    },
     alertError(message) {
      this.$swal.fire({
        title: "Peringatan!",
        icon: "error",
        text: message,
        showCancelButton: true
      });
    },

    alertSuccess() {
      var vm = this;

      const Toast = vm.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        onOpen: toast => {
          toast.addEventListener("mouseenter", vm.$swal.stopTimer);
          toast.addEventListener("mouseleave", vm.$swal.resumeTimer);
        }
      });
      Toast.fire({
        icon: "success",
        title: "Data Berhasil Disimpan"
      });
    },
    
    getData(){
      KuesionerService.getKuesionerAll()
      .then(response => {
        this.dat_kuesioner = response.data.data.content;
      })
      .catch(error => {
        // comment console console.log(error);
      });
    },
    add_kuesioner(index) {
      this.formData.pertanyaan.push({
        idPertanyaanKuesioner: "",
        pertanyaan: "",
        idPertanyaan: "",
      });

    },

    remove_kuesioner(index) {
      this.formData.pertanyaan.splice(index, 1);
      return false;
    },

    addCandidate() {
      axios
        .post("/candidates", { my_prop_name: JSON.stringify(this.kuesioner) })
        .then(response => {})
        .catch(error => {});
    }
  }
};
</script>